<template>
    <div>
        <!--新增QRCode弹框-->
        <el-dialog :title="$t('AddQRCodeUnlock')" 
            :close-on-click-modal="false" 
            :close-on-press-escape="false" 
            :visible.sync="addQRCode.addQRCodeFrom" 
            center 
            :show-close="addQRCode.showClose" 
        >
            <div class="addsiteUersBox">
                <div class="addSiteUserLeft">
                    <el-form>
                        <el-form-item :label="$t('Name') + ' *'">
                            <el-input style="width: 96%;" v-model="addQRCode.title"></el-input>
                        </el-form-item>
                        <div class="NameBox">
                            <div style="width:48%">
                                <el-form-item :label="$t('UnlockQRCode')">
                                    <el-button style="margin-top: 10px;width: 100%;" type="primary" disabled>{{$t('ClickToDisplay')}}</el-button>
                                </el-form-item>
                            </div>
                            <div style="width:48%">
                                <el-form-item :label="$t('UnlockOption') + ' *'">
                                    <el-select v-model="addQRCode.locks" multiple :placeholder="$t('PleaseSelect')">
                                        <el-option
                                        v-for="item in addQRCode.locksOptions"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            
                        </div>
                        <div class="LimitContent" style="margin-top:20px;padding-top:20px;">
                            <div class="LimitBox">
                                <div style="width:48%;">
                                    <el-form-item :label="$t('Limited')" label-width="100px">
                                        <el-input v-model="addQRCode.countLimit" :disabled="addQRCode.countLimitDis"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="cardText">
                                    <span style="font-size: 16px;">{{$t('NumbeOfUses')}}</span>
                                </div>
                            </div>
                            <div class="LimitBox">
                                <div class="cardText">
                                    <span style="font-size: 16px;">{{$t('Unlinmited')}}</span>
                                </div>
                                <div class="cardText">
                                    <el-switch
                                    @change="addQRCodeUnlinmitChage"
                                    v-model="addQRCode.Unlinmited">
                                    </el-switch>
                                </div>
                            </div>
                        </div>
                        <div class="LimitContent" style="margin-top: 10px;border-bottom: 1px solid #ddd; padding-top:20px;padding-bottom:30px;">
                            <div class="LimitBox">
                                <div>
                                    <el-form-item :label="$t('ValidityTime')" :title="$t('ValidityTime')" class="ValidityTimeLable" label-width="120px">
                                        <el-date-picker
                                        :disabled="addQRCode.isFovever"
                                        style="width: 46%;font-size:14px;"
                                        v-model="addQRCode.startTime"
                                        type="datetime"
                                        value-format="timestamp"
                                        :placeholder="$t('StartTime')">
                                        </el-date-picker> ~ 
                                        <el-date-picker
                                        :disabled="addQRCode.isFovever"
                                        style="width: 46%;font-size:14px;"
                                        v-model="addQRCode.endTime"
                                        type="datetime"
                                        value-format="timestamp"
                                        :placeholder="$t('EndTime')">
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="FoveverBox">
                                <div style="padding-right: 20px; margin-top: 20px;color: #333;">
                                    <el-form-item :label="$t('Forever')" :title="$t('Forever')" class="ValidityTimeLable" label-width="120px">
                                        <el-switch
                                            @change="addQRCodeForeverChage"
                                            v-model="addQRCode.fovever">
                                        </el-switch>
                                    </el-form-item>
                                    
                                </div>
                            </div>
                        </div>
                        
                    </el-form>
                </div>
                <div class="addSiteUserRight">
                    <div>{{$t('PanelSync')}}</div>
                    <div class="licenseBox" style="height: 380px;">
                        <div v-for="item in addQRCode.devList" :key="item.id" style="margin-bottom: 5px">
                            <el-checkbox  v-model="item.isChecked">{{item.deviceName}}</el-checkbox>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer addCard">
                <el-button @click="addQRCode.addQRCodeFrom = false">{{$t('Cancel')}}</el-button>
                <el-button type="primary" :loading="addQRCode.addBtnState === 1" class="selectBtn" style="margin-left: 60px !important" @click="addQRCodeUnlock">{{$t('Confirm')}}</el-button>
            </div>
             <!--QRCode展示弹框-->
            <el-dialog
                :title="$t('QRCode')"
                :visible.sync="downloadQRCode.downloadQRCodeFrom"
                :close-on-click-modal="false" 
                :close-on-press-escape="false"
                @close="closeQRCodeFrom"
                width="500px"
                append-to-body
                :show-close="downloadQRCode.showClose">
                <p class="deleteDesc">{{$t('ShareQRCode')}}</p>
                <div style="margin-top: 25px; display: flex;justify-content: center;">
                    <div style=" width: 185px;height: 185px;" ref="unlockQRcodeDownload">

                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" class="selectBtn" :loading="delQRCode.delBtnState === 1" @click="downloadUnlockQRCode">{{$t('DownloadTemplate')}}</el-button>
                </span>
            </el-dialog>
        </el-dialog>
       
        <!--编辑QRCode弹框-->
        <el-dialog :title="$t('EditQRCodeUnlock')" 
            :close-on-click-modal="false" 
            :close-on-press-escape="false" 
            :visible.sync="editQRCode.editQRCodeFrom" 
            center 
            :show-close="editQRCode.showClose" 
        >
            <div class="addsiteUersBox">
                <div class="addSiteUserLeft">
                    <el-form>
                        <el-form-item :label="$t('Name')  + ' *'">
                            <el-input style="width: 96%;" v-model="editQRCode.title"></el-input>
                        </el-form-item>
                        <div class="NameBox">
                            <div style="width:48%">
                                <el-form-item :label="$t('UnlockQRCode')">
                                    <el-button  @click="editUnlockQRCode" style="margin-top: 10px;width: 100%;" type="primary">{{$t('ClickToDisplay')}}</el-button>
                                </el-form-item>
                            </div>
                            <div style="width:48%">
                                <el-form-item :label="$t('UnlockOption') + ' *'">
                                    <el-select disabled v-model="editQRCode.locks" multiple :placeholder="$t('PleaseSelect')">
                                        <el-option
                                        v-for="item in editQRCode.locksOptions"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="LimitContent" style="margin-top:20px;padding-top:20px;">
                            <div class="LimitBox">
                                <div style="width:48%;">
                                    <el-form-item :label="$t('Limited')" label-width="100px">
                                        <el-input v-model="editQRCode.countLimit" disabled></el-input>
                                    </el-form-item>
                                </div>
                                <div class="cardText">
                                    <span style="font-size: 16px;">{{$t('NumbeOfUses')}}</span>
                                </div>
                            </div>
                            <div class="LimitBox">
                                <div class="cardText">
                                    <span style="font-size: 16px;">{{$t('Unlinmited')}}</span>
                                </div>
                                <div class="cardText">
                                    <el-switch
                                    disabled
                                    @change="editQRCodeUnlinmitChage"
                                    v-model="editQRCode.Unlinmited">
                                    </el-switch>
                                </div>
                            </div>
                        </div>
                        <div class="LimitContent" style="margin-top: 10px;border-bottom: 1px solid #ddd; padding-top:20px;padding-bottom:30px;">
                            <div class="LimitBox">
                                <div>
                                    <el-form-item :label="$t('ValidityTime')" :title="$t('ValidityTime')" class="ValidityTimeLable" label-width="120px">
                                        <el-date-picker
                                        disabled
                                        style="width: 46%; font-size:14px;"
                                        v-model="editQRCode.startTime"
                                        type="datetime"
                                        value-format="timestamp"
                                        :placeholder="$t('StartTime')">
                                        </el-date-picker> ~ 
                                        <el-date-picker
                                        disabled
                                        style="width: 46%;font-size:14px;"
                                        v-model="editQRCode.endTime"
                                        type="datetime"
                                        value-format="timestamp"
                                        :placeholder="$t('EndTime')">
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="FoveverBox">
                                <div style="padding-right: 20px; margin-top: 20px;color: #333;">
                                    <el-form-item :label="$t('Forever')" :title="$t('Forever')" class="ValidityTimeLable" label-width="120px">
                                        <el-switch
                                            disabled
                                            @change="editQRCodeForeverChage"
                                            v-model="editQRCode.fovever">
                                        </el-switch>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </el-form>
                </div>
                <div class="addSiteUserRight">
                    <div>{{$t('PanelSync')}}</div>
                    <div class="licenseBox" style="height: 380px;">
                        <div v-for="item in editQRCode.devList" :key="item.id" style="margin-bottom: 5px;display:flex;justify-content: space-between;">
                            <el-checkbox  v-model="item.isChecked">{{item.deviceName}}</el-checkbox>
                            <div v-show="item.isChecked" style="color:#999;font-size:14px;">{{handPanelApplyStatus(item.applyStatus)}}</div>
                        </div>
                    </div>
                    <!-- 编辑时二维码生成处 -->
                    <!-- <div ref="unlockQRcodeEdit" @click="editUnlockQRCode" class="unlockQRcodeEditDiv">

                    </div> -->
                </div>
            </div>
            <div slot="footer" class="dialog-footer addCard">
                <el-button @click="editQRCode.editQRCodeFrom = false">{{$t('Cancel')}}</el-button>
                <el-button type="primary" :loading="editQRCode.editBtnState === 1" class="selectBtn" style="margin-left: 60px !important" @click="editQRcodeUnlock">{{$t('Confirm')}}</el-button>
            </div>
            <!--QRCode展示弹框(编辑)-->
            <el-dialog
                :title="$t('QRCode')"
                :visible.sync="downloadQRCodeEdit.downloadQRCodeFrom"
                :close-on-click-modal="false" 
                :close-on-press-escape="false"
                width="500px"
                append-to-body
                :show-close="downloadQRCodeEdit.showClose">
                <p class="deleteDesc">{{$t('ShareQRCode')}}</p>
                <div style="margin-top: 25px; display: flex;justify-content: center;">
                    <div style=" width: 185px;height: 185px;" ref="unlockQRcodeDownloadEdit">

                    </div>
                </div>
                <span slot="footer" class="dialog-footer" style="text-align: center;">
                    <el-button type="primary" class="selectBtn" :loading="delQRCode.delBtnState === 1" @click="downloadUnlockQRCodeEdit">{{$t('DownloadTemplate')}}</el-button>
                </span>
            </el-dialog>
        </el-dialog>
        <!--删除QRCode弹框-->
        <el-dialog
            :title="$t('Delete')"
            :visible.sync="delQRCode.delQRCodeFrom"
            :close-on-click-modal="false" 
            :close-on-press-escape="false"
            width="500px"
            :show-close="delQRCode.showClose">
            <p class="deleteDesc">{{$t('ConfirmDeleteQRCode')}}</p>
            <span slot="footer" class="dialog-footer addCard">
                <el-button @click="delQRCode.delQRCodeFrom = false">{{$t('Cancel')}}</el-button>
                <el-button type="primary" class="selectBtn" style="margin-left: 60px !important" :loading="delQRCode.delBtnState === 1" @click="delQRCodeSetting">{{$t('Confirm')}}</el-button>
            </span>
        </el-dialog>
        <div class="noSipsettings" v-show="qrCode.hasNoQRCode">{{$t('NoData')}}!</div>
        <template>
            <el-table
            v-show="!qrCode.hasNoQRCode"
            :data="qrCode.qrcodeList"
            style="width: 100%;"
            :header-cell-style="{background:'#EDEFFB',color:'#4D4D4F'}"
            >
                <el-table-column
                    label="#"
                    type="index"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="title"
                    :label="$t('Name')"
                    >
                </el-table-column>
                
                <el-table-column
                    prop="locks"
                    :label="$t('LockTemplate')"
                    >
                </el-table-column>
                <el-table-column
                    prop="countLimit"
                    :label="$t('LimitedUse')"
                    >
                    <template slot-scope="scope">
                        {{handCountLimit(scope.row.countLimit,scope.row.usedCount)}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="startTime"
                    :label="$t('ValidityTime')"
                    >
                    <template slot-scope="scope">
                        {{validityTime(scope.row.startTime,scope.row.endTime)}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="entranceDeviceIds"
                    :label="$t('PanelSync')"
                    show-overflow-tooltip
                    >
                    <template slot-scope="scope">
                        {{showPanelsName(scope.row.entranceDeviceIds)}}
                    </template>
                </el-table-column>
                <el-table-column width="150"  label="..." align="center">
                    <template slot-scope="scope">
                        <el-image :src="qrCode.editImg" :title="$t('Edit')"  @click="editQRCodeSetting(scope.row)" style="width:24px;" fit="fill"></el-image>
                        <el-image :src="qrCode.deleteImg" :title="$t('Delete')"  @click="openDelQRCodeFrom(scope.row)" style="width:24px;margin-left:1vw" fit="fill"></el-image>
                    </template>
                </el-table-column>
            </el-table>
        </template>
    </div>
  
</template>

<script>
import CryptoJS from 'crypto-js';
import { encryptCBC, decryptCBC } from "@/util/aes";
import QRCode from 'qrcodejs2'
import SnowflakeId from 'snowflake-id'
import { mapState } from 'vuex';
import sitesUsersApi from '@/api/siteusers/index.js'
import editImg from '@/assets/images/edit.png'
import deleteImg from '@/assets/images/delete.png'
export default {
    name:"QRCodeUnlock",
    data(){
        return{
            updateSiteUser:{
                id:"",
                userId:"",
            },
            qrCode:{
                hasNoQRCode:false,
                qrcodeList:[],
                editImg,
                deleteImg,
            },
            addQRCode:{
                addQRCodeFrom:false,
                showClose:true,
                title:"",
                // addCardType:"",
                payload:"",
                locks:"",
                locksOptions:[
                    {
                        id:"1",
                        name:"Lock 1"
                    },
                    {
                        id:"2",
                        name:"Lock 2"
                    },
                ],
                countLimitDis:false,
                countLimit:"",
                Unlinmited:false,
                devList:[],
                startTime:"",
                endTime:"",
                isFovever:false,
                fovever:false,
                addBtnState:0,
            },
            editQRCode:{
                editQRCodeFrom:false,
                showClose:true,
                entranceKeyId:"",
                title:"",
                payload:"",
                locks:"",
                locksOptions:[
                    {
                        id:"1",
                        name:"Lock 1"
                    },
                    {
                        id:"2",
                        name:"Lock 2"
                    },
                ],
                countLimitDis:false,
                countLimit:1,
                Unlinmited:false,
                devList:[],
                entranceDeviceList:[],
                startTime:"",
                endTime:"",
                isFovever:false,
                fovever:false,
                userId:"",
                // facilityCode:"",
                cardNumber:"",
                editBtnState:0,
            },
            delQRCode:{
                delQRCodeFrom:false,
                showClose:true,
                entranceKeyId:"",
                delBtnState:0,
            },
            downloadQRCode:{
                downloadQRCodeFrom:false,
                showClose:true,
                entranceKeyId:"",
                delBtnState:0,
            },
            downloadQRCodeEdit:{
                downloadQRCodeFrom:false,
                showClose:true,
                entranceKeyId:"",
                delBtnState:0,
            },
        }
    },
    mounted(){
       this.updateSiteUser.id = this.$route.params.id;
       this.updateSiteUser.userId = this.$route.params.userId;
    //    console.log("this.$route.params",this.$route.params,this.updateSiteUser.id);
       this.getSiteUserQRCodeDevicesList();
       //获取qrcode 开锁 配置列表
       this.getSiteQRCodeList();      
    },
    methods:{
        //10进制转为16进制
        decimalToHex(decimal) {
            return decimal.toString(16).toUpperCase();
        },
        //16进制转为10进制
        hexToDecimal(hexString) {
            return parseInt(hexString, 16);
        },
        //base64转为16进制字符串
        base64ToHex(base64String) {
            // 解码Base64字符串
            const byteArray = atob(base64String)
                .split('')
                .map(char => char.charCodeAt(0));
            
            // 转换为16进制字符串
            return byteArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
        },
        //字符串前面补0，直到满足长度要求
        padStringToLength(str, desiredLength) {
            return str.padStart(desiredLength, '0');
        },
        //字节数组转为16进制字符串
        byteToHex(arr) {
            let hexStr = "";
            for (let i = 0; i < arr.length; i++) {
                let hex = arr[i].toString(16);
                if (hex.length === 1) {
                hex = "0" + hex;
                }
                hexStr += hex;
            }
            return hexStr;
        },
        //16进制转base64
        hexStringToBase64(hexString) {
            // 将16进制字符串转换为Uint8Array
            const byteArray = new Uint8Array(hexString.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
            
            // 使用btoa将二进制数据转换为Base64字符串
            const base64String = btoa(String.fromCharCode(...byteArray));
            
            return base64String;
        },
        //HmacSHA1签名函数
        Hmacstr(sigstr, key) {
            let result = CryptoJS.HmacSHA1(sigstr, key);
            let sig = result.toString(CryptoJS.enc.Hex);
            return sig;
        },
        //查询住宅有权限设备列表
        getSiteUserQRCodeDevicesList(){
            let devicesInfoObj = {
                "rgn":this.selectCompany.companyRegion,
                "siteId":this.selectSite.id,
                "userHouseId":this.updateSiteUser.id,
                "pageSize":-1,
                "pageNum":1,
            }
            //解决当前页面刷新后，由于路由参数改变导致updateSiteUser.id获取不到，获取用户密码配置命令出错 code:8
            if(!this.updateSiteUser.id){
                return
            }
            sitesUsersApi.getSiteUserDevicesList(devicesInfoObj).then(res => {
                if(res.code === 0){
                    this.addQRCode.devList = [];
                    this.editQRCode.devList = [];
                    if(res.data === null || res.data.list.length === 0){
                        this.addQRCode.devList = [];
                        this.editQRCode.devList = [];
                    }else{
                        res.data.list.forEach(item => {
                            if(item.accessStatus === 1 && this.$getBit(this.$base64ToByteArray(item.entranceAbility), 6) === 1){
                                item.isChecked = false;
                                this.addQRCode.devList.push(item);
                                this.editQRCode.devList.push(item);
                            }
                            
                        })
                    }
                }else{
                    this.addQRCode.devList = [];
                    this.editQRCode.devList = [];
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                this.addQRCode.devList = [];
                this.editQRCode.devList = [];
                // console.log(err);
            })
        },
        //查询用户QRCode Unlock列表
        getSiteQRCodeList(){
            let qrcodeInfoObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            let qrcodePostObj = {
                "userHouseId":this.updateSiteUser.id,
                "userId":this.updateSiteUser.userId,
                "type":2,
            }
            //解决当前页面刷新后，由于路由参数改变导致updateSiteUser.id获取不到，获取用户密码配置命令出错 code:8
            if(!this.updateSiteUser.id){
                return false
            }
            sitesUsersApi.getSiteUserCardConfigList(qrcodeInfoObj,qrcodePostObj).then(res => {
                if(res.code === 0){
                    this.qrCode.qrcodeList = [];
                    if(res.data === null || res.data.length === 0){
                        this.qrCode.qrcodeList = [];
                        this.qrCode.hasNoQRCode = true;
                    }else{
                        this.qrCode.hasNoQRCode = false;
                        for(let i=0;i<res.data.length;i++){
                            this.qrCode.qrcodeList.push(res.data[i]);
                        }
                    }
                }else{
                    this.qrCode.qrcodeList = [];
                    this.qrCode.hasNoQRCode = true;
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                this.qrCode.qrcodeList = [];
                this.qrCode.hasNoQRCode = true;
                console.log(err);
            })
        },
        //解密二维码
        decryptQRCodeUnlock(val){
            //将tdk+userHouseId使用SHA256生成AES加密KEY
            let payloadKey = CryptoJS.SHA256("tdk"+this.updateSiteUser.id);
            //把获取到的16进制的字符串转为base64
            let base64Str = this.hexStringToBase64(val);
            // console.log("val",val)
            // console.log("base64Str",base64Str)
            //解密之后二维码
            let cardNumHex = decryptCBC(base64Str,payloadKey,CryptoJS.enc.Hex.parse(this.byteToHex(new Uint8Array(16))));
            // console.log("cardNumHex",cardNumHex)
            return cardNumHex
        },
        //处理次数
        handCountLimit(count,usedCount){
            let countLimitStr = "";
            if(count === 0){
                countLimitStr = this.$t('Unlinmited');
            }else{
                countLimitStr = usedCount + "/" + count;
            }
            return countLimitStr
        },
        //处理有效期
        validityTime(start,end){
            let validityStr = "";
            if(start === 0 && end === 0){
                validityStr = this.$t('Forever');
            }else{
                validityStr = this.utctolocal(start) + " ~ " + this.utctolocal(end);
            }
            return validityStr
        },
         //panels 名称显示
         showPanelsName(panelList){
            let panelStr = "";
            if(this.addQRCode.devList.length != 0){
                this.addQRCode.devList.map(item =>{
                    panelList.map(item2 =>{
                        if(item.id === item2){
                            panelStr += item.deviceName +  "\u2003"
                        }
                    })
                })
            }
            return panelStr;
        },
         //处理设备应用状态函数
         handPanelApplyStatus(statu){
            let statuStr = "";
           switch (statu) {
            case 0:
                statuStr = this.$t('NotApplied');
                break;
            case 1:
                statuStr = this.$t('ApplicationComplete');
                break;
            case 2:
                statuStr = this.$t('DataValidationFailed');
                break;
            case 3:
                statuStr = this.$t('TypesNotSupported');
                break;
            case 4:
                statuStr = this.$t('DeviceLimitedInput');
                break;
            case 5:
                statuStr = this.$t('DeviceDataDuplication');
                break;
            default:
                statuStr = "";
           }
            return statuStr
        },
        addQRCodeSetting(){
            this.addQRCode.addQRCodeFrom = true;
            this.addQRCode.title = "";
            this.addQRCode.payload = "";
            this.addQRCode.locks = "";
            this.addQRCode.countLimit = "";
            this.addQRCode.countLimitDis = false;
            this.addQRCode.Unlinmited = false;
            this.addQRCode.startTime = "";
            this.addQRCode.endTime = "";
            this.addQRCode.isFovever = false;
            this.addQRCode.fovever = false;
            this.addQRCode.devList.map(item =>{
                item.isChecked = false;
            })
        },
        //添加QRCode 不限次数开关改变函数
        addQRCodeUnlinmitChage(item){
            if(item){
                this.addQRCode.countLimit = "";
                this.addQRCode.countLimitDis = true;
            }else{
                this.addQRCode.countLimitDis = false;
            }
        },
        //添加QRCode 永久有效开关改变函数
        addQRCodeForeverChage(item){
            if(item){
                this.addQRCode.startTime = "";
                this.addQRCode.endTime = "";
                this.addQRCode.isFovever = true;
            }else{
                this.addQRCode.isFovever = false;
            }
        },
      
        //添加QRCode Unlock配置点击确定执行函数
        addQRCodeUnlock(){
            let checkCardName = this.$regularCheckLimit(this.addQRCode.title,1,64,'NameCannotEmpty');
            if(!checkCardName){
                return false
            }
            // if(this.addQRCode.payload === ""){
            //     this.$message.info(this.$t('CardNumberEmpty'));
            //     return false
            // }
            if(this.addQRCode.locks.length == 0){
                this.$message.info(this.$t('UnlockOptionEmpty'));
                return false
            }
            let finCountLimit = 0;
            if(this.addQRCode.Unlinmited){
                finCountLimit = 0;
            }else{
                // if(this.addQRCode.countLimit === ""){
                //     this.$message.info(this.$t('LimitedEmpty'));
                //     return false
                // }else{
                //     if(Number(this.addQRCode.countLimit) > 999){
                //         this.$message.info(this.$t('LimitUnlockNum').replace('100','999'));
                //         return false
                //     }
                // }
                let countLimitReg = /^([1-9][0-9]{0,2})$|^[1-9]$/;
                if(!countLimitReg.test(this.addQRCode.countLimit)){
                    this.$message.info(this.$t('LimitUnlockNumLimit'));
                    return false
                }
                finCountLimit = this.addQRCode.countLimit;
            }
            let finStartTime = 0;
            let finEndTime = 0;
            if(this.addQRCode.fovever){
                finStartTime = 0;
                finEndTime = 0;
            }else{
                if(this.addQRCode.startTime == null){
                    this.addQRCode.startTime = "";
                }
                if(this.addQRCode.endTime == null){
                    this.addQRCode.endTime = "";
                }
                if(this.addQRCode.startTime === ""){
                    this.$message.info(this.$t('StartTimeEmptye'));
                    return false
                }
                if(this.addQRCode.endTime === ""){
                    this.$message.info(this.$t('EndTimeEmptye'));
                    return false
                }
                if(this.addQRCode.startTime != "" && this.addQRCode.endTime != ""){
                    if(this.addQRCode.startTime >= this.addQRCode.endTime){
                        this.$message.info(this.$t('StartTimeLaterEndTime'));
                        return false
                    }
                }
                finStartTime = this.addQRCode.startTime;
                finEndTime = this.addQRCode.endTime;

            }
            let finDevArr = [];
            this.addQRCode.devList.map(item =>{
                if(item.isChecked){
                    finDevArr.push(item.id)
                }
            })
            if(finDevArr.length === 0){
                this.$message.info(this.$t('PleaseSelectPanels'));
                return false
                
            }
            this.addQRCode.payload = this.createUnlockQrCodeText();
            //将tdk+userHouseId使用SHA256生成AES加密KEY
            let payloadKey = CryptoJS.SHA256("tdk"+this.updateSiteUser.id);
            let encryStr = encryptCBC(this.addQRCode.payload,payloadKey,CryptoJS.enc.Hex.parse(this.byteToHex(new Uint8Array(16))));
            let nowTimeTamp = new Date().getTime();
            let rgnObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            let addUserQRCodeObj = {
                "type": 2,
                "userHouseId":this.updateSiteUser.id,
                // "userId":this.updateSiteUser.userId,
                "checkKeyId": nowTimeTamp, 
                "title": this.addQRCode.title,
                "payload": this.base64ToHex(encryStr),
                "payloadSha": CryptoJS.SHA256(this.addQRCode.payload),
                // "cardType": 24,
                "locks": this.addQRCode.locks.join(","),
                "countLimit": finCountLimit,
                "startTime": finStartTime,
                "endTime": finEndTime,
                "entranceDeviceIds": finDevArr,
                "timestamp": nowTimeTamp,
                "createTime": nowTimeTamp,
            };
            // console.log("addUserQRCodeObj",addUserQRCodeObj);
            // return false
            const sortedData = Object.keys(addUserQRCodeObj)
                    .sort()
                    .map(key => `${key}=${addUserQRCodeObj[key]}`)
                    .join("&");
            // 创建 formData 对象
            const formData = new FormData();
            formData.append('userHouseId', this.updateSiteUser.id);
            formData.append('userId', this.updateSiteUser.userId);
            formData.append('type', 2);
            formData.append('checkKeyId', nowTimeTamp);
            formData.append('title', this.addQRCode.title);
            formData.append('payload', this.base64ToHex(encryStr));
            formData.append('payloadSha', CryptoJS.SHA256(this.addQRCode.payload));
            // formData.append('cardType', 24);
            formData.append('locks', this.addQRCode.locks.join(","));
            formData.append('countLimit', finCountLimit);
            formData.append('startTime', finStartTime);
            formData.append('endTime', finEndTime);
            formData.append('entranceDeviceIds', finDevArr);
            formData.append('timestamp', nowTimeTamp);
            formData.append('createTime', nowTimeTamp);
            formData.append('sign', this.Hmacstr(sortedData,this.updateSiteUser.id));
            this.addQRCode.addBtnState = 1;
            sitesUsersApi.addSiteUserCardConfig(rgnObj,formData).then(res => {
                if(res.code === 0){
                    this.$message.success(this.$t('AddSuccessful'));
                    this.addQRCode.addBtnState = 0;
                    //获取QRCode 配置列表
                    this.getSiteQRCodeList();
                    // this.addQRCode.addQRCodeFrom = false;
                    this.showDownQrcode();
                }else{
                    this.addQRCode.addBtnState = 0;
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                console.log(err);
                this.addQRCode.addBtnState = 0;
            })
        },
        //关闭新增成功后二维码展示框
        closeQRCodeFrom(){
            this.addQRCode.addQRCodeFrom = false;
        },
        //二维码开锁列表点击编辑
        editQRCodeSetting(item){
            this.editQRCode.editQRCodeFrom = true;
            let qrcodeInfoObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            let qrcodePostObj = {
                "userHouseId":this.updateSiteUser.id,
                "entranceKeyId":item.entranceKeyId,
                "userId":item.userId,
            }
            sitesUsersApi.getSiteUserCardDetail(qrcodeInfoObj,qrcodePostObj).then(res => {
                if(res.code === 0){
                   this.editQRCode.title = res.data.title;
                   //将tdk+userHouseId使用SHA256生成AES加密KEY
                   let payloadKey = CryptoJS.SHA256("tdk"+this.updateSiteUser.id);
                   //把获取到的16进制的字符串转为base64
                   let base64Str = this.hexStringToBase64(res.data.payload);
                   //解密之后得二维码
                   let cardNumHex = decryptCBC(base64Str,payloadKey,CryptoJS.enc.Hex.parse(this.byteToHex(new Uint8Array(16))));
                   this.editQRCode.payload = cardNumHex;
                   this.editQRCode.userId = res.data.userId;
                   this.editQRCode.entranceKeyId = res.data.entranceKeyId;
                   this.editQRCode.locks = (res.data.locks).split(",");
                   if(res.data.countLimit === 0){
                       this.editQRCode.countLimit = "";
                       this.editQRCode.countLimitDis = true;
                       this.editQRCode.Unlinmited = true;
                   }else{
                       this.editQRCode.countLimitDis = false;
                       this.editQRCode.Unlinmited = false;
                       this.editQRCode.countLimit = res.data.countLimit;
                   }
                   if(res.data.startTime === 0 && res.data.endTime === 0){
                       this.editQRCode.startTime = "";
                       this.editQRCode.endTime = "";
                       this.editQRCode.isFovever = true;
                       this.editQRCode.fovever = true;
                   }else{
                       this.editQRCode.startTime = res.data.startTime;
                       this.editQRCode.endTime = res.data.endTime;
                       this.editQRCode.isFovever = false;
                       this.editQRCode.fovever = false;
                   }
                   this.editQRCode.entranceDeviceList = res.data.entranceDeviceList;
                   this.editQRCode.devList.map(item=>{
                        item.isChecked = false;
                        if (item.hasOwnProperty('applyStatus')) {
                            delete item.applyStatus
                        }
                    })
                    // console.log("this.editQRCode.entranceDeviceList",this.editQRCode.entranceDeviceList)
                    this.editQRCode.devList.map(item=>{
                        this.editQRCode.entranceDeviceList.map(item2=>{
                            if(item.id === item2.entranceDeviceId){
                                item.isChecked = true;
                                item.applyStatus = item2.applyStatus;
                            }
                        })
                    })
                    //编辑调用生成二维码函数
                    // this.createUnlockQrCodeEdit();
                }else{
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                console.log(err);
            })
            
        },
        //编辑QRCode 不限次数开关改变函数
        editQRCodeUnlinmitChage(item){
            if(item){
                this.editQRCode.countLimit = "";
                this.editQRCode.countLimitDis = true;
            }else{
                this.editQRCode.countLimitDis = false;
            }
        },
        //编辑QRCode 永久有效开关改变函数
        editQRCodeForeverChage(item){
            if(item){
                this.editQRCode.startTime = "";
                this.editQRCode.endTime = "";
                this.editQRCode.isFovever = true;
            }else{
                this.editQRCode.isFovever = false;
            }
        },

        //编辑QRCode确认
        editQRcodeUnlock(){
            let checkCardName = this.$regularCheckLimit(this.editQRCode.title,1,64,'NameCannotEmpty');
            if(!checkCardName){
                return false
            }
            // if((this.editQRCode.payload.toString()).trim() === ""){
            //     this.$message.info(this.$t('CardNumberEmpty'));
            //     return false
            // }
            if(this.editQRCode.locks.length == 0){
                this.$message.info(this.$t('UnlockOptionEmpty'));
                return false
            }
            let finCountLimit = 0;
            if(this.editQRCode.Unlinmited){
                finCountLimit = 0;
            }else{
                // if(this.editQRCode.countLimit === ""){
                //     this.$message.info(this.$t('LimitedEmpty'));
                //     return false
                // }else{
                //     if(Number(this.editQRCode.countLimit) > 999){
                //         this.$message.info(this.$t('LimitUnlockNum').replace('100','999'));
                //         return false
                //     }
                // }
                let countLimitReg = /^([1-9][0-9]{0,2})$|^[1-9]$/;
                if(!countLimitReg.test(this.editQRCode.countLimit)){
                    this.$message.info(this.$t('LimitUnlockNumLimit'));
                    return false
                }
                finCountLimit = this.editQRCode.countLimit;
            }
            let finStartTime = 0;
            let finEndTime = 0;
            if(this.editQRCode.fovever){
                finStartTime = 0;
                finEndTime = 0;
            }else{
                if(this.editQRCode.startTime == null){
                    this.editQRCode.startTime = "";
                }
                if(this.editQRCode.endTime == null){
                    this.editQRCode.endTime = "";
                }
                if(this.editQRCode.startTime === ""){
                    this.$message.info(this.$t('StartTimeEmptye'));
                    return false
                }
                if(this.editQRCode.endTime === ""){
                    this.$message.info(this.$t('EndTimeEmptye'));
                    return false
                }
                if(this.editQRCode.startTime != "" && this.editQRCode.endTime != ""){
                    if(this.editQRCode.startTime >= this.editQRCode.endTime){
                        this.$message.info(this.$t('StartTimeLaterEndTime'));
                        return false
                    }
                }
                finStartTime = this.editQRCode.startTime;
                finEndTime = this.editQRCode.endTime;

            }
            let finDevArr = [];
            this.editQRCode.devList.map(item =>{
                if(item.isChecked){
                    finDevArr.push(item.id)
                }
            })
            if(finDevArr.length === 0){
                this.$message.info(this.$t('PleaseSelectPanels'));
                return false
                
            }
            //将tdk+userHouseId使用SHA256生成AES加密KEY
            let payloadKey = CryptoJS.SHA256("tdk"+this.updateSiteUser.id);
            // 先转16进制 在加密 
            // let finCardNum = this.decimalToHex(Number(this.editQRCode.payload));
            let encryStr = encryptCBC(this.editQRCode.payload,payloadKey,CryptoJS.enc.Hex.parse(this.byteToHex(new Uint8Array(16))));
            let nowTimeTamp = new Date().getTime();
            let rgnObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            let editUserQRCodeObj = {
                "type": 2,
                "userHouseId":this.updateSiteUser.id,
                "entranceKeyId":this.editQRCode.entranceKeyId,
                // "checkKeyId": new Date().getTime(), 
                "title": this.editQRCode.title,
                // "payload": this.base64ToHex(encryStr),
                // "cardType": 24,
                "locks": this.editQRCode.locks.join(","),
                "countLimit": finCountLimit,
                "startTime": finStartTime,
                "endTime": finEndTime,
                "entranceDeviceIds": finDevArr,
                "timestamp": nowTimeTamp,
            };
            const sortedData = Object.keys(editUserQRCodeObj)
                    .sort()
                    .map(key => `${key}=${editUserQRCodeObj[key]}`)
                    .join("&");
            // 创建 formData 对象
            const formData = new FormData();
            formData.append('userHouseId', this.updateSiteUser.id);
            formData.append('userId', this.updateSiteUser.userId);
            formData.append('entranceKeyId', this.editQRCode.entranceKeyId);
            formData.append('type', 2);
            formData.append('checkKeyId', nowTimeTamp);
            formData.append('title', this.editQRCode.title);
            // formData.append('payload', this.base64ToHex(encryStr));
            // formData.append('cardType', 24);
            formData.append('locks', this.editQRCode.locks.join(","));
            formData.append('countLimit', finCountLimit);
            formData.append('startTime', finStartTime);
            formData.append('endTime', finEndTime);
            formData.append('entranceDeviceIds', finDevArr);
            formData.append('timestamp', nowTimeTamp);
            formData.append('sign', this.Hmacstr(sortedData,this.updateSiteUser.id));
            this.editQRCode.editBtnState = 1;
            sitesUsersApi.updateSiteUserCardConfig(rgnObj,formData).then(res => {
                if(res.code === 0){
                    this.$message.success(this.$t('UpdateSuccessfully'));
                    this.editQRCode.editBtnState = 0;
                    //获取QRCode 配置列表
                    this.getSiteQRCodeList();
                    this.editQRCode.editQRCodeFrom = false;
                }else{
                    this.editQRCode.editBtnState = 0;
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                console.log(err);
                this.editQRCode.editBtnState = 0;
            })
        },
        //删除QRCode弹窗
        openDelQRCodeFrom(item){
            this.delQRCode.delQRCodeFrom = true;
            this.delQRCode.entranceKeyId = item.entranceKeyId;
        },
        //删除QRCode 确认
        delQRCodeSetting(){
            let rgnObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            const delSiteUserQRCodeObj = {}
            delSiteUserQRCodeObj.entranceKeyId = [];
            delSiteUserQRCodeObj.entranceKeyId.push(this.delQRCode.entranceKeyId);
            delSiteUserQRCodeObj.userHouseId = this.updateSiteUser.id;
            delSiteUserQRCodeObj.userId = this.updateSiteUser.userId;
            this.delQRCode.delBtnState = 1;
            sitesUsersApi.delSiteUserCard(rgnObj,delSiteUserQRCodeObj).then(res => {
                if(res.code === 0){
                    this.delQRCode.delBtnState = 0;
                    this.$message.success(this.$t('DeleteSuccessfully'));
                    this.delQRCode.delQRCodeFrom = false;
                    //获取QRCode 配置列表
                    this.getSiteQRCodeList();
                }else{
                    this.delQRCode.delBtnState = 0;
                    this.$handerrcode(res.code);
                }
                
            }).catch((err) => {
                this.delQRCode.delBtnState = 0;
                console.log('err', err);
            })
            
        },
        //将数字转为62进制
        toBase62(num) {
            // 定义62进制字符集
            const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
            const radix = chars.length;
            
            // 处理大数字，确保输入为数字类型
            let number = typeof num === 'string' ? parseInt(num, 10) : num;
            
            if (number === 0) return '0';
            if (number < 0) {
                throw new Error('不支持负数转换');
            }
            
            let result = '';
            
            while (number > 0) {
                const remainder = number % radix;
                result = chars[remainder] + result;
                number = Math.floor(number / radix);
            }
            
            return result;
        },
        //生成开锁码(雪花算法)
        createUnlockQrCodeText(){
            let qrcodeStr = '';
            if(this.updateSiteUser.id){
                let snowflake = new SnowflakeId({
                    mid : this.updateSiteUser.id.slice(-6),
                });
                let getSnowId = snowflake.generate();
                qrcodeStr = this.toBase62(Number(getSnowId));
            }
            return qrcodeStr;
        },

        //生成app加入二维码
        createUnlockQrCode() {
            this.$refs.unlockQRcodeDownload.innerHTML = '';
            new QRCode(this.$refs.unlockQRcodeDownload, {
                text: this.addQRCode.payload,
                width: 200,
                height: 200,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })
        },
        //展示开锁二维码
        showDownQrcode(){
            this.downloadQRCode.downloadQRCodeFrom = true;
            this.$nextTick(() => {
                this.createUnlockQrCode();
            });
        },
        //下载开锁二维码
        downloadUnlockQRCode(){
            // 获取二维码图片元素
            const imgElement = this.$refs.unlockQRcodeDownload.querySelector('img')
            
            if (!imgElement) {
                console.error('未找到二维码图片元素')
                return
            }
            // // 创建一个临时链接
            // const link = document.createElement('a')
            // link.href = imgElement.src
            // // link.download = `${this.filename}.png`
            // link.download = this.addQRCode.title + ".png";
            
            // // 触发点击下载
            // document.body.appendChild(link)
            // link.click()
            // document.body.removeChild(link)

            // 创建 Canvas
            const canvas = document.createElement('canvas')
            const ctx = canvas.getContext('2d')
            
            // 设置内边距（单位：px）
            const padding = 24
            
            // 获取原图尺寸
            const img = new Image()
            img.crossOrigin = 'anonymous' // 如果图片跨域需要设置
            img.onload = () => {
                // Canvas 尺寸 = 原图尺寸 + 2 * padding
                canvas.width = img.width + padding * 2
                canvas.height = img.height + padding * 2
                
                // 白色背景（作为内边距）
                ctx.fillStyle = '#ffffff'
                ctx.fillRect(0, 0, canvas.width, canvas.height)
                
                // 绘制二维码（偏移 padding）
                ctx.drawImage(img, padding, padding, img.width, img.height)
                
                // 下载
                const link = document.createElement('a')
                link.download = `${this.addQRCode.title}.png`
                link.href = canvas.toDataURL('image/png')
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            }
            img.onerror = () => {
                // 如果图片加载失败，尝试直接下载原图
                console.warn('图片加载失败，使用原图下载')
                const link = document.createElement('a')
                link.href = imgElement.src
                link.download = `${this.addQRCode.title}.png`
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            }
            img.src = imgElement.src
        },

        //编辑生成二维码
        // createUnlockQrCodeEdit() {
        //     this.$refs.unlockQRcodeEdit.innerHTML = '';
        //     new QRCode(this.$refs.unlockQRcodeEdit, {
        //         text: this.editQRCode.payload,
        //         width: 185,
        //         height: 185,
        //         colorDark: '#6498b5',
        //         colorLight: '#ffffff',
        //         correctLevel: QRCode.CorrectLevel.H
        //     })
        // },
        //点击编辑开锁二维码
        editUnlockQRCode(){
            this.downloadQRCodeEdit.downloadQRCodeFrom = true;
            this.$nextTick(() => {
                this.createDownloadUnlockQrCodeEdit();
            });
        },
        //点击编辑开锁二维码生成要下载的二维码
        createDownloadUnlockQrCodeEdit() {
            this.$refs.unlockQRcodeDownloadEdit.innerHTML = '';
            new QRCode(this.$refs.unlockQRcodeDownloadEdit, {
                text: this.editQRCode.payload,
                width: 185,
                height: 185,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })
        },
        //编辑下载开锁二维码
        downloadUnlockQRCodeEdit(){
            // 获取二维码图片元素
            const imgElement = this.$refs.unlockQRcodeDownloadEdit.querySelector('img')
            
            if (!imgElement) {
                console.error('未找到二维码图片元素')
                return
            }
            // // 创建一个临时链接
            // const link = document.createElement('a')
            // link.href = imgElement.src
            // link.download = this.editQRCode.title + ".png";
            
            // // 触发点击下载
            // document.body.appendChild(link)
            // link.click()
            // document.body.removeChild(link)

             // 创建 Canvas
            const canvas = document.createElement('canvas')
            const ctx = canvas.getContext('2d')
            
            // 设置内边距（单位：px）
            const padding = 24
            
            // 获取原图尺寸
            const img = new Image()
            img.crossOrigin = 'anonymous' // 如果图片跨域需要设置
            img.onload = () => {
                // Canvas 尺寸 = 原图尺寸 + 2 * padding
                canvas.width = img.width + padding * 2
                canvas.height = img.height + padding * 2
                
                // 白色背景（作为内边距）
                ctx.fillStyle = '#ffffff'
                ctx.fillRect(0, 0, canvas.width, canvas.height)
                
                // 绘制二维码（偏移 padding）
                ctx.drawImage(img, padding, padding, img.width, img.height)
                
                // 下载
                const link = document.createElement('a')
                link.download = `${this.editQRCode.title}.png`
                link.href = canvas.toDataURL('image/png')
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            }
            img.onerror = () => {
                // 如果图片加载失败，尝试直接下载原图
                console.warn('图片加载失败，使用原图下载')
                const link = document.createElement('a')
                link.href = imgElement.src
                link.download = `${this.editQRCode.title}.png`
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            }
            img.src = imgElement.src
        },
        
    },
    computed:{
        ...mapState(["selectCompany","selectSite"])
    },
    watch:{
      
    }
}
</script>

<style scoped>
.addsiteUersBox{
    display: flex;
}
.addSiteUserLeft{
    width: 50%;
    padding-right: 1vw;
}
.NameBox{
    display: flex;
    justify-content: space-between;
}

.addSiteUserRight{
    width: 50%;
    font-size: 18px !important;
    margin-left: 2vw;
}
.addSiteUserRight p {
    font-size: 16px;
    color: #CFCFCF;
}
.addSiteUserRight p span{
    color: #6498b5;
}
::v-deep .addSiteUserRight .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 100%;
    border: none;
    background: #EFEFEF;
}
.licenseBox{
    background: #EFEFEF;
    margin-top: 1vw;
    padding: 1vw 1vw;
    height: 105px;
    overflow-y: auto;
    border-radius: 10px;
}
.LimitContent{
    border-top:1px solid #ddd;
    /* border-radius: 8px; */
    padding-bottom: 15px;
}
.LimitBox{
    display: flex;
    justify-content: space-between;
    height: 45px;
}
::v-deep .LimitBox label{
    margin-top: 10px !important;
}
.FoveverBox{
    display: flex;
    justify-content: space-between;
    height: 45px;
}
.cardText{
    width:48%;
    text-align: right;
    padding-right: 20px; 
    margin-top: 20px;color: #333;
}
::v-deep .el-form-item__label{
    text-align: left;
}
.addCard .el-button--primary {
    margin-left: 60px !important;
    color: #fff;
    background-color: #6498b5;
    border-color: #6498b5;
}
.unlockQRcodeEditDiv {
    width: 185px;
    height: 185px;
    margin-top: 25px;
}
.unlockQRcodeEditDiv:hover {
    cursor: pointer;
}

::v-deep .el-dialog {
    border-radius: 15px !important;
    width: 1200px;
}

::v-deep .el-dialog__header {
    background-color: #6498b5 !important;
    border-radius: 15px 15px 0 0 !important;
    text-align: center;
}
::v-deep .el-dialog__title {
    color: #fff !important;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 24px;
    line-height: 0.6;
}
::v-deep .el-dialog__headerbtn:focus .el-dialog__close,
::v-deep .el-dialog__headerbtn:hover .el-dialog__close {
  color: #fff !important;
}
::v-deep .el-dialog__footer {
    padding: 10px 20px 35px;
    text-align: center !important;
}
</style>